module.exports = __webpack_public_path__ + "img/腳色介面_03-完成3.cef34a5c.png";